/**
 * Imágenes de Softball Season-Ready (DPS-33).
 *
 * Los mockups reales están en Drive (carpeta del producto > mockup):
 *   - DPS33 - Principal - Softball Season-Ready.png  -> hero
 *   - DPS33 - Bono 1..5 - *.png                      -> bonusCovers[0..4]
 * Subirlos a Magic Patterns y pegar acá la URL del CDN.
 *
 * Mientras un campo esté vacío, la página muestra un "pack shot" o una
 * portada dibujada en código con la paleta del producto (nunca un ícono roto).
 */
export const images = {
  hero: '',
  bonusCovers: [
    'https://cdn.magicpatterns.com/uploads/1GQyC8WBi9TRyx5YZfWqfa/DPS33_-_Bono_1_-_The_Parent-Helper_Playbook.png',
    'https://cdn.magicpatterns.com/uploads/pBfkg8NAkYgQ7Ds9KjJ9CM/DPS33_-_Bono_2_-_Softball_Rules_Made_Simple_for_Coaches.png',
    'https://cdn.magicpatterns.com/uploads/6GzrK8dGX9HdAdHUmixRf8/DPS33_-_Bono_3_-_The_Scorebook_Made_Simple.png',
    'https://cdn.magicpatterns.com/uploads/fz1q8MDrBzKbmCRv8nVSjR/DPS33_-_Bono_4_-_Gear__Field_Setup_on_Any_Budget.png',
    'https://cdn.magicpatterns.com/uploads/fRRii2f1ShLkz9S8LJFVkH/DPS33_-_Bono_5_-_Softball_Decoded_-_Terms__Positions.png',
  ],
  /** Páginas reales de los tomos (export de Gamma), en el orden de LookInside. */
  pages: [
    'https://cdn.magicpatterns.com/uploads/6XmQ9t9bf9xGkCiytpvq5z/vol5_p1.png', // Portada Vol. 5
    'https://cdn.magicpatterns.com/uploads/tdWUSzPKwa9RxU9kX6YnAt/vol5_p28.png', // Práctica 4 bloques
    'https://cdn.magicpatterns.com/uploads/tzroSNkLb8iTATFSwB57Wr/vol5_p24.png', // Drill card (bunt)
    'https://cdn.magicpatterns.com/uploads/tuGSHsoxAqSuZ89w3sDpiv/vol5_p33.png', // This vs. that (play in / back)
    'https://cdn.magicpatterns.com/uploads/bXZyQXm1eeSNqaCAdw3nNh/vol5_p22.png', // Diagrama de campo (cutoff)
    'https://cdn.magicpatterns.com/uploads/hvQYqLbYL1eUagTkhT389o/vol5_p50.png', // Field card
  ],
}
